import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as itemsActions from 'store/modules/items';
import * as calcActions from 'store/modules/calc';
import StatInvenWeaponView from 'components/calc/StatInvenWeaponView';
// import StatInvenArmorView from 'components/calc/StatInvenArmorView';
import { weaponSkillList } from 'util/damageCalc';


class StatInvenContainer extends Component {

  componentDidMount() {
    
  }

  componentDidUpdate(prevProps) {
    const {CalcActions, currSelWeapon, myStat} = this.props;
    const {selSkillSeq} = myStat;
    
    if (
      prevProps.currSelWeapon === currSelWeapon &&
      prevProps.myStat.selSkillSeq === selSkillSeq
    ) {
      return;
    }

    const {currItem} = currSelWeapon;
    const {ITEM_DTL_DV} = currItem;

    //선택한무기가 선택되있는 스킬을 못쓰는경우 선택한스킬+선택한탄창속성 초기화
    const currItemSkill = weaponSkillList.filter(skill => {
      return skill.weaponType === ITEM_DTL_DV;
    });
    
    const isSkillValid =
      selSkillSeq === '0' ||
      currItemSkill.some(skill => skill.seq === selSkillSeq);

    if (!isSkillValid) {
      CalcActions.initStat();
    }
  }

  inputClick = (e) => {
    e.target.select();
  }

  setStat = (e) => {
    const {CalcActions} = this.props;
    const {name, value, type} = e.target;

    if(type === 'number') {
      if(Number(value) > -1 && Number(value) < 1001) {
        CalcActions.setStat({name, value});
      }
    }else{
      CalcActions.setStat({name, value});
    }
  }
  
  render() {
    const {inputClick, setStat} = this;
    const {myStat, currSelWeapon/*, currSelArmmor, itemFilters*/} = this.props;

    return (
      // itemKind === '04' ? 
      // <StatInvenArmorView/> :
      <StatInvenWeaponView 
      inputClick={inputClick}
      setStat={setStat}
      myStat={myStat}
      currSelWeapon={currSelWeapon}
      />
    );
  }
}

export default connect(
  (state) => ({
    myStat: state.calc.toJS().myStat,
    currSelWeapon: state.items.toJS().currSelWeapon,
    currSelArmmor: state.items.toJS().currSelArmmor,
    itemFilters: state.items.toJS().itemFilters
  }),
  (dispatch) => ({
    CalcActions: bindActionCreators(calcActions, dispatch),
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(StatInvenContainer);